import { concat, of, catchError, switchMap, map  } from 'rxjs';
import { ofType } from 'redux-observable';
import mapDataSlice from './dataSlice';
import { selectMapResults } from './selectors';
import getInteractiveSitePlansInformation$ from '../apis/getCommunityInteractiveSitePlans';
import { processInteractiveSitePlan } from '../services/processSitePlans';
import SitePlanType from '../enums/sitePlanType';

const actions = mapDataSlice.actions;

const fetchInteractiveSitePlansEpic = (action$, state$) =>
  action$.pipe(
    ofType(actions.fetchResultsFulfilled.type),
    switchMap(() => {
      const interactiveCommunityIds = (selectMapResults(state$.value) ?? [])
        .filter((result) => SitePlanType.Interactive.toString() === result.sitePlanType)
        .map((result) => result.communityId);

      return concat(
        of(actions.fetchInteractiveSitePlans()),
        getInteractiveSitePlansInformation$(interactiveCommunityIds).pipe(
          map((data) => actions.fetchInteractiveSitePlansFulfilled(data.map(processInteractiveSitePlan))),
          catchError((error) => of(actions.fetchInteractiveSitePlansError(error)))
        )
      );
    })
  );

export default fetchInteractiveSitePlansEpic;